import ConfirmationEmail from './ConfirmationEmail';

export default ConfirmationEmail;
